import React, { useContext } from 'react';
import { Button } from '../../../../../components/ui/Button/Button';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { MainLocales } from '../../../../../locales/locales.interfaces';
import { store } from '../../../../../store/store';
import { hideHomePageDialog } from '../../../../../utils/home-page-dialog-state-handlers';
import { logger } from '../../../../../utils/logger';
import dialogsStyle from '../Dialogs.module.scss';

export const Success = () => {
  const { dispatch } = useContext(store);
  const { t } = useTranslation<MainLocales>('mainLocales');

  const handleDoneClick = () => {
    try {
      hideHomePageDialog(dispatch);
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <div className={dialogsStyle.content}>
      <div className={dialogsStyle.left}>
        <h1>{t('endSuccessTitle')}</h1>
        <p className={dialogsStyle.info}>{t('endSuccessEmailInfo')}</p>
        <div>
          <Button type='primary' onClick={handleDoneClick}>
            {t('successDone')}
          </Button>
        </div>
      </div>
      <div className={dialogsStyle.right}>
        <h1>{t('endPreparationTitle')}</h1>
        <p>Please bring your booking confirmation email with you and show it to the testing team upon arrival together with your passport.</p>
        <p>We cannot process your test without these two documents.</p>
      </div>
    </div>
  );
};
